import { Skeleton } from "@/components/ui/skeleton";

const LiveOpsSkeleton = () => (
  <div className="bg-zinc-900/50 border border-zinc-800 rounded-xl p-4">
    <div className="flex items-center justify-between mb-4">
      <Skeleton className="h-4 w-28" />
      <Skeleton className="h-3 w-12" delay={40} />
    </div>
    {[0, 1].map((i) => (
      <div key={i} className="flex items-center gap-3 py-2 border-t border-zinc-800/60">
        <Skeleton className="h-9 w-9 rounded-full" delay={80 + i * 60} />
        <div className="flex-1">
          <Skeleton className="h-3 w-32 mb-1.5" delay={100 + i * 60} />
          <Skeleton className="h-2.5 w-44" delay={120 + i * 60} />
        </div>
      </div>
    ))}
  </div>
);

export default LiveOpsSkeleton;
